'use client';

import { Box, Container, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import CardGrid from './CardGrid';
import SectionShell from '../../components/SectionShell';
export default function Section4Simple() {
  return <SectionShell data-sentry-element="SectionShell" data-sentry-component="Section4Simple" data-sentry-source-file="index.tsx">
      <CardGrid data-sentry-element="CardGrid" data-sentry-source-file="index.tsx" />
    </SectionShell>;
}